import { z } from 'zod';
export const AutomationActionTypeSchema = z.enum(['CREATE_CRM_FOLLOW_UP', 'CREATE_INTERNAL_OPERATIONAL_ALERT']);
export const AutomationRunStatusSchema = z.enum(['RUNNING', 'SUCCEEDED', 'RETRYABLE_FAILURE', 'FAILED']);
export const AutomationAlertSeveritySchema = z.enum(['INFO', 'WARNING', 'CRITICAL']);
const AutomationRuleContextSchema = z.object({
    organizationId: z.string().uuid(),
    branchId: z.string().uuid(),
    name: z.string().trim().min(3).max(160),
    triggerEventType: z.enum([
        'crm.customer.created', 'crm.customer.updated', 'crm.contact.updated',
        'crm.lead.created', 'crm.lead.status_changed', 'crm.lead.assigned',
        'crm.lead.source_changed', 'crm.task.created', 'crm.task.completed',
        'crm.task.assigned', 'crm.task.reopened',
    ]),
    conditions: z.object({ metadataContains: z.record(z.string(), z.unknown()).optional() }).strict().default({}),
    maxAttempts: z.number().int().min(1).max(3).default(3),
}).strict();
export const AutomationFollowUpActionSchema = AutomationRuleContextSchema.extend({
    actionType: z.literal('CREATE_CRM_FOLLOW_UP'),
    actionConfig: z.object({
        title: z.string().trim().min(3).max(240),
        assigneeMembershipId: z.string().uuid(),
        dueInMinutes: z.number().int().min(0).max(10_080).optional(),
    }).strict(),
}).strict();
export const AutomationOperationalAlertActionSchema = AutomationRuleContextSchema.extend({
    actionType: z.literal('CREATE_INTERNAL_OPERATIONAL_ALERT'),
    actionConfig: z.object({
        title: z.string().trim().min(3).max(240),
        severity: AutomationAlertSeveritySchema.optional(),
    }).strict(),
}).strict();
export const AutomationCreateRuleSchema = z.discriminatedUnion('actionType', [
    AutomationFollowUpActionSchema, AutomationOperationalAlertActionSchema,
]);
export const AutomationSetRuleEnabledSchema = z.object({ isEnabled: z.boolean() }).strict();
export const AutomationExecuteRuleSchema = z.object({ triggerTimelineEventId: z.string().uuid() }).strict();
export const AutomationListQuerySchema = z.object({ organizationId: z.string().uuid(), limit: z.number().int().min(1).max(100).default(100) }).strict();
export const AutomationRuleSchema = z.object({
    id: z.string().uuid(), branchId: z.string().uuid(), name: z.string(), triggerEventType: z.string(),
    conditions: z.object({ metadataContains: z.record(z.string(), z.unknown()).optional() }).strict(),
    actionType: AutomationActionTypeSchema, actionConfig: z.record(z.string(), z.unknown()),
    maxAttempts: z.number().int().min(1).max(3), isEnabled: z.boolean(), createdAt: z.string(), updatedAt: z.string(),
}).strict();
export const AutomationRunSchema = z.object({
    id: z.string().uuid(), ruleId: z.string().uuid(), branchId: z.string().uuid(), triggerTimelineEventId: z.string().uuid(),
    status: AutomationRunStatusSchema, attemptCount: z.number().int().min(0).max(3), maxAttempts: z.number().int().min(1).max(3),
    lastErrorCode: z.string().nullable(), createdAt: z.string(), completedAt: z.string().nullable(),
    actionType: AutomationActionTypeSchema.nullable(), crmTaskId: z.string().uuid().nullable(), operationalAlertId: z.string().uuid().nullable(),
}).strict();
/** A bounded, already-provenanced CRM event eligible to trigger a CT-05 rule. */
export const AutomationTriggerEventSchema = z.object({
    id: z.string().uuid(),
    branchId: z.string().uuid(),
    eventType: z.string().min(1).max(128),
    occurredAt: z.string(),
}).strict();
export const AutomationRulesResponseSchema = z.object({ success: z.literal(true), data: z.array(AutomationRuleSchema).max(100) }).strict();
export const AutomationRunsResponseSchema = z.object({ success: z.literal(true), data: z.array(AutomationRunSchema).max(100) }).strict();
export const AutomationTriggerEventsResponseSchema = z.object({ success: z.literal(true), data: z.array(AutomationTriggerEventSchema).max(100) }).strict();
export const AutomationCommandResponseSchema = z.object({ success: z.literal(true), data: z.object({ id: z.string().uuid() }).strict() }).strict();
//# sourceMappingURL=automation.js.map